import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@cinch-labs/design-system";
var TextFieldWrapper = function(_param) /*#__PURE__*/ {
    var _errorDisplay = _param.errorDisplay, errorDisplay = _errorDisplay === void 0 ? "realtime" : _errorDisplay, input = _param.input, meta = _param.meta, onBlur = _param.onBlur, tooltip = _param.tooltip, label = _param.label, inputRef = _param.inputRef, rest = _object_without_properties(_param, [
        "errorDisplay",
        "input",
        "meta",
        "onBlur",
        "tooltip",
        "label",
        "inputRef"
    ]);
    return _jsx(TextField, _object_spread_props(_object_spread({}, rest), {
        label: label,
        id: rest["id"],
        name: input.name,
        type: input.type ? input.type : "text",
        value: input.value,
        onChange: input.onChange,
        onBlur: function(e) {
            input.onBlur(e);
            if (onBlur) onBlur(e);
        },
        onFocus: input.onFocus,
        ref: inputRef
    }));
};
export default TextFieldWrapper;
